/**
 * ajaxHandler for handling ajax request
 *
 * @since 1.0.0
 * @param {*} formData 
 * @returns json response
 */
export async function ajaxHandler(formData, jsonRes = true) {
	const { ajax_url, nonce_field, nonce_value } = platformObject;

	// Append nonce field to form data
	formData.append(nonce_field, nonce_value);
	try {
		const post = await fetch(ajax_url, {
			method: 'POST',
			body: formData,
		});
		if (post.ok) {
			if (jsonRes) {
				return await post.json();
			} else {
				await post.text();
			}
		}
	} catch (error) {
		console.log(error)
	}
}

export function platformFormData(data = []) {
	const formData = new FormData();
	data.forEach((item) => {
		for (const [key, value] of Object.entries(item)) {
			formData.set(key, value)
		}
	});
	return formData;
}

export const spinnerElem = `<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>`;

export const toast = {
	success: function (message) {
		const toastElement = this.getTemplate('primary', message);
		document.body.appendChild(toastElement);
		setTimeout(() => {
			document.body.removeChild(toastElement);
		}, 3000);
	},
	error: function (message) {
		const toastElement = this.getTemplate('danger', message);
		document.body.appendChild(toastElement);
		setTimeout(() => {
			document.body.removeChild(toastElement);
		}, 3000);
	},
	getTemplate: function (variant, message) {
		const wrapper = document.createElement('div');
		wrapper.innerHTML = `
		<div class="toast-container position-fixed bottom-0 start-0 p-3">
			<div class="toast fade show align-items-center text-bg-${variant} border-0" role="alert" aria-live="assertive" aria-atomic="true">
				<div class="d-flex">
				<div class="toast-body">
					${message}
				</div>
				<button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
				</div>
			</div>
		</div>
		`
		return wrapper;
	}
};

window.toast = toast; // For tickets application

export function debounce(func, delay) {
	let timeoutId;
	return function (...args) {
		const context = this;
		clearTimeout(timeoutId);
		timeoutId = setTimeout(() => {
			func.apply(context, args);
		}, delay);
	};
}

export function isMobileDevice() {
	return /Mobi|Android/i.test(navigator.userAgent);
}
